export class RouteDataModel {
  roles?: string[];
  navbarConfig?: [];
  label?: string;
}
